import { logger } from '../../../../utils/common/logger'
import { DOMUtils } from '../../../../utils/dom'
import { Store } from '../../../../utils/storage/keys'
import { IdentityEvent } from '../../../common/events/identity'
import { LoginRadiusApiClient } from '../loginradius/services/api-client'
import { LoginService } from '../loginradius/services/login-service'
import { IdentityScreen } from '../loginradius/widgets/base'
import { IdentityFormAPI } from './form-api'
import { IdentityFormUtils } from './form-utils'

export class OTPEntryForm {
    private static DOM = {
        class: {
            otpEmail: 'otp-email'
        },
        form: 'verifyOTPForm',
    }

    private email = ''

    private appName: string

    private apiKey: string

    private jwtApp = 'news-websites'

    private lrApiClient: LoginRadiusApiClient

    public constructor(appName: string, apiKey: string ) {
        this.appName = appName
        this.apiKey = apiKey
    }

    /**
     * Listens for the form validated event in the verify OTP email form
     */
    public init() {
        logger('debug', 'Initializing verify OTP email form')
        const verifyOTPForm = document.querySelector(`[data-id-form=${OTPEntryForm.DOM.form}]`)
        const otpEmail = document.querySelector(`.${OTPEntryForm.DOM.class.otpEmail}`)

        if (sessionStorage) {
            this.email = sessionStorage.getItem(Store.OTP_EMAIL)
        }

        if (otpEmail) {
            otpEmail.textContent = this.email
        }

        if (verifyOTPForm) {
            document.addEventListener(IdentityEvent.FORM_VALIDATED, async (event: CustomEvent) => {
                const formType = event.detail.form
                if (formType === OTPEntryForm.DOM.form) {
                    await this.submitForm()
                }
            })
        }

        DOMUtils.addClass(document.body, IdentityScreen.FORM)
        logger('debug', 'Verify OTP form initialized')
    }

    /**
     * Calls verify OTP token API
     */
    public async submitForm() {
        const formData = IdentityFormUtils.getFields()
        const otp = formData.oneTimePasscode

        IdentityFormUtils.clearError()

        if (!this.email) {
            IdentityFormUtils.showError('Incorrect Secure code, please try again.')
            logger('error', 'Email address not found')
            return
        }

        try {
            // call verify OTP token API
            const response = await IdentityFormAPI.verifyPasswordlessOTP({email: this.email, otp})

            if (response.access_token) {
                // verify passwordless api call success
                const accessToken = response.access_token

                logger('debug', 'Passwordless login successful')
                LoginService.sendFormSubmissionEvent('verify-otp')

                if (sessionStorage) {
                    sessionStorage.removeItem(Store.OTP_EMAIL)
                }

                if (localStorage) {
                    localStorage.setItem(Store.LR_TOKEN_KEY, accessToken)
                    this.lrApiClient = new LoginRadiusApiClient(this.apiKey, this.jwtApp, accessToken, this.appName)

                    const jwtToken = await this.lrApiClient.getJwtToken()
                    localStorage.setItem(Store.JWT, jwtToken)
                    await LoginService.handleLoginSuccess({ ...response, jwttoken: jwtToken})
                }
            } else if (response.otp && Array.isArray(response.otp)) {
                // verify passwordless api call error
                throw new Error(response.otp[0])
            }
        } catch (err) {
            IdentityFormUtils.showError('Incorrect Secure code, please try again.')
            logger('error', 'Unable to verify OTP', err)
        }
    }
}
